import React, { useState } from 'react';
import { AiFileInfo } from '../../types/IAiConversation';
import useApiDownload from '../../hooks/useApiDownload';
import DownloadIcon from '../icons/DownloadIcon';

const KIND_LABELS: Record<string, string> = { xlsx: 'XLS', pptx: 'PPT' };

const formatSize = (bytes: number) => {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  if (bytes >= 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${bytes} B`;
};

const extensionOf = (name: string) =>
  name.split('.').pop()?.toLowerCase() ?? '';

interface IProps {
  file: AiFileInfo;
}

// A file the assistant produced, downloaded through the authenticated route.
const FileChip = ({ file }: IProps) => {
  const download = useApiDownload();
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);
  const extension = extensionOf(file.fileName);

  const onClick = async () => {
    if (busy) return;
    setBusy(true);
    setFailed(false);
    const { ok } = await download(file.downloadUrl, file.fileName);
    setFailed(!ok);
    setBusy(false);
  };

  return (
    <button
      type="button"
      className={`chat-file${failed ? ' chat-file--failed' : ''}`}
      onClick={onClick}
      disabled={busy}
      title={
        failed
          ? 'The download failed. Click to try again.'
          : `Download ${file.fileName}`
      }
    >
      <span className={`chat-file-kind chat-file-kind--${extension}`}>
        {KIND_LABELS[extension] ?? 'FILE'}
      </span>
      <span className="chat-file-name">{file.fileName}</span>
      <span className="chat-file-meta">
        {busy ? 'Downloading…' : formatSize(file.sizeBytes)}
      </span>
      <DownloadIcon />
    </button>
  );
};

export default FileChip;
